import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import {
  createCredit,
  createCreditSuccess,
  createCreditFailure,
  getCredits,
  getCreditsFailure,
  getCreditsSuccess,
  removeCredit,
  removeCreditFailure,
  removeCreditSuccess,
  updateCredit,
  updateCreditFailure,
  updateCreditSuccess,
  getCreditById,
  getCreditByIdFailure,
  getCreditByIdSuccess,
} from '.';

import creditService from 'src/services/CreditService';

function* rootSaga() {
  yield takeLatest(createCredit, createCreditSaga);
  yield takeLatest(getCredits, getCreditsSaga);
  yield takeLatest(removeCredit, removeCreditSaga);
  yield takeLatest(updateCredit, updateCreditSaga);
  yield takeLatest(getCreditById, getCreditByIdSaga);
}

function* createCreditSaga({ payload }) {
  try {
    yield delay(300);
    const createdCredit = yield call(creditService.create, payload);
    yield put(createCreditSuccess(createdCredit));
  } catch (error) {
    yield put(createCreditFailure(error));
  }
}

function* getCreditsSaga({ payload }) {
  try {
    yield delay(300);
    const response = yield call(creditService.getAllCredits, payload);
    yield put(getCreditsSuccess(response));
  } catch (error) {
    yield put(getCreditsFailure(error));
  }
}

function* getCreditByIdSaga({ payload }) {
  const creditId = payload;
  try {
    yield delay(300);
    const response = yield call(creditService.getById, creditId);
    yield put(getCreditByIdSuccess(response));
  } catch (error) {
    yield put(getCreditByIdFailure(error));
  }
}

function* removeCreditSaga({ payload }) {
  const id = payload;
  try {
    yield delay(300);
    const response = yield call(creditService.remove, id);
    const tableParams = yield select(({ credits }) => credits.credits.tableParams);
    yield put(getCredits(tableParams));
    yield put(removeCreditSuccess(response));
  } catch (error) {
    yield put(removeCreditFailure(error));
  }
}

function* updateCreditSaga({ payload }) {
  try {
    yield delay(300);
    const response = yield call(creditService.update, payload);
    const tableParams = yield select(({ credits }) => credits.credits.tableParams);
    yield put(getCredits(tableParams));
    yield put(updateCreditSuccess(response));
  } catch (error) {
    yield put(updateCreditFailure(error));
  }
}


export default rootSaga;
